import React, { useState, useEffect, useMemo } from 'react';
import { textTranslations } from './error/text-translations';
import { useLanguage } from './LanguageContext';
import Ghosted from './homepage/Home';
import Header from './Header';
import Footer from './Footer';
import GetStartedViaWhatsapp from './GetStartedViaWhatsapp';

const Error = () => {
  
  const { language } = useLanguage();

  const [errorType, setErrorType] = useState("support");
  
  const query = useMemo(() => {
        return new URLSearchParams(window.location.search);
  }, []);

  useEffect(() => {

    const error = query?.get("error") || query?.get("type") || "unknown_error";
    if (
      error === "customer-not-verified" ||
      error === "unpaid" ||
      error === "missing_info" ||
      error === "access_denied" ||
      error === "not-a-customer"
    ) {
      setErrorType("not-a-customer");
    } else {
      setErrorType(error);
    }

  }, []);    

  return (
    <>
     <Header />
     <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp" alt="Boggler Logo" className="descriptor-image" style={{ width: "120px", height: "auto", margin: "20px auto", display: "block" }} />
     <section className="main-body-section">
       <h1 className="lucky-font" style={{ fontSize: "2rem" }}>{textTranslations("title", language)}</h1>
       <div>{textTranslations("unknown-error", language)}</div>
       <div>{textTranslations(errorType === "support" ? "support-line" : "customer-not-verified", language)}</div>
       {errorType === "support" && <div>
          <button onClick={() => window.open("mailto:buck@theboggler.com", "_self")} className="cta-button">{textTranslations("contact-support", language)}</button>
          <h2 style={{fontSize: "40px"}}>💩</h2>
       </div>}
       <GetStartedViaWhatsapp />
     </section>
     <Footer />
    </>
  );
}

export default Error;
